import type { WheelItemsData, WheelItem } from '../wheelData'

export default function getParents(item: WheelItem, wheelItemsData: WheelItemsData): WheelItem[] {
  const parent = wheelItemsData[item].parent
  const grandParent = parent && wheelItemsData[parent].parent
  if (grandParent) {
    return [grandParent, parent]
  } else if (parent) {
    return [parent]
  } else {
    return []
  }
}
